module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-information-settings"
  }, [_c('div', {
    staticClass: "row mx-0 mb-2 mt-2"
  }, [_c('Textarea', {
    staticClass: "col-12 col-md-6 ps-md-0",
    attrs: {
      "label": "ОБО МНЕ",
      "placeholder": "Расскажите о себе"
    },
    model: {
      value: (_vm.about_me),
      callback: function($$v) {
        _vm.about_me = $$v
      },
      expression: "about_me"
    }
  }), _c('Textarea', {
    staticClass: "col-12 col-md-6 pe-md-0",
    attrs: {
      "label": "КЛЮЧЕВЫЕ НАВЫКИ",
      "placeholder": "Введите ключевые навыки. Например, работа в команде, публичные выступления, организация мероприятий и т.п."
    },
    model: {
      value: (_vm.key_skills),
      callback: function($$v) {
        _vm.key_skills = $$v
      },
      expression: "key_skills"
    }
  }), _c('div', {
    staticClass: "col-12 col-md-6 ps-md-0 mt-3"
  }, [_c('Select', {
    staticClass: "w-100",
    attrs: {
      "options": _vm.driverLicenseDict,
      "label": "НАЛИЧИЕ ПРАВ КАТЕГОРИИ",
      "placeholder": "Выберите категорию прав",
      "multiple": "multiple",
      "clearable": "clearable"
    },
    model: {
      value: (_vm.drivers_license),
      callback: function($$v) {
        _vm.drivers_license = $$v
      },
      expression: "drivers_license"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-md-6 pe-md-0 mt-3"
  }, [_c('FormInput', {
    staticClass: "w-100",
    attrs: {
      "v": _vm.$v.site,
      "error-text": _vm.$util.validationMessage(_vm.$v.site, "https://test.test"),
      "label": "ЛИЧНЫЙ САЙТ",
      "maxlength": "255",
      "placeholder": "Введите адрес сайта",
      "multiple": "multiple"
    },
    model: {
      value: (_vm.site),
      callback: function($$v) {
        _vm.site = $$v
      },
      expression: "site"
    }
  })], 1), _c('Checkbox', {
    staticClass: "col-12 px-0 mt-3",
    model: {
      value: (_vm.is_car),
      callback: function($$v) {
        _vm.is_car = $$v
      },
      expression: "is_car"
    }
  }, [_vm._v("Наличие автомобиля")]), _c('div', {
    staticClass: "col-12 col-md-6 ps-md-0 mt-3"
  }, [_c('Select', {
    staticClass: "w-100",
    attrs: {
      "filterable": true,
      "options": _vm.worldLanguageDict,
      "label": "РОДНОЙ ЯЗЫК",
      "placeholder": "Выберите родной язык",
      "clearable": "clearable",
      "default-value": ""
    },
    model: {
      value: (_vm.native_language),
      callback: function($$v) {
        _vm.native_language = $$v
      },
      expression: "native_language"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-md-6 pe-md-0 my-0"
  }), _vm._l((_vm.foreign_language), function(language, index) {
    return [_c('div', {
      staticClass: "col-12 col-md-6 ps-md-0 mt-3"
    }, [_c('Select', {
      staticClass: "w-100",
      attrs: {
        "filterable": true,
        "options": _vm.worldLanguageDict,
        "label": "ЗНАНИЕ ИНОСТРАННОГО ЯЗЫКА",
        "placeholder": "Выберите иностранный язык"
      },
      model: {
        value: (_vm.foreign_language[index].language),
        callback: function($$v) {
          _vm.$set(_vm.foreign_language[index], "language", $$v)
        },
        expression: "foreign_language[index].language"
      }
    })], 1), _c('div', {
      staticClass: "col-12 col-md-6 pe-md-0 mt-3 relative"
    }, [_c('Select', {
      style: ({
        width: "calc(100% - 30px)"
      }),
      attrs: {
        "options": _vm.languageLevelDict,
        "label": "УРОВЕНЬ ЗНАНИЯ ЯЗЫКА",
        "placeholder": "Выберите уровень знания языка"
      },
      model: {
        value: (_vm.foreign_language[index].level),
        callback: function($$v) {
          _vm.$set(_vm.foreign_language[index], "level", $$v)
        },
        expression: "foreign_language[index].level"
      }
    }), _c('AppSvgIcon', {
      staticClass: "ui_cursor__pointer px-0 py-0 ui_color__red",
      staticStyle: {
        "position": "absolute",
        "right": "0",
        "top": "25px"
      },
      attrs: {
        "template": _vm.$ui.IconSvgComponents.close,
        "color-mode": "stroke"
      },
      on: {
        "click": function($event) {
          return _vm.removeLanguage(index)
        }
      }
    })], 1)]
  }), _c('div', {
    staticClass: "col-12 col-md-6 ps-md-0 mt-3"
  }, [_c('Button', {
    attrs: {
      "alignSelf": "end"
    },
    on: {
      "click": _vm.appendLanguage
    }
  }, [_vm._v("ДОБАВИТЬ ЯЗЫК")])], 1), _c('div', {
    staticClass: "col-12 col-md-6 pe-md-0 mt-3"
  }), _c('div', {
    staticClass: "col-12 col-md-6 ps-md-0 mt-3"
  }, [_c('Message', {
    attrs: {
      "accent": _vm.correctUpdateProfile,
      "bottom": true,
      "color": _vm.color
    }
  }, [_c('div', {
    staticClass: "flex-column d-flex"
  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _vm._l((_vm.errorsProp), function(error) {
    return (error.msg) ? _c('span', [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _c('Button', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Сохранить изменения")])], 1), _c('div', {
    staticClass: "col-12 col-md-6 pe-md-0 mt-3 d-flex"
  }, [_c('Button', {
    staticClass: "mt-auto",
    attrs: {
      "alignSelf": "end",
      "bordered": true
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Отменить изменения")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a80a548","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/additional/Addittional.vue
// module id = 85237c475e0ba357fb14
// module chunks = 73